export default __webpack_public_path__ + "static/media/window-popout.e68711f6.svg";